const setCSSVar = (n, v, e) => {
  (e || document.documentElement).style.setProperty(`--${n}`, v);
};

const addElementClass = (el, className) => {
  if (el) {
    if (el.classList) el.classList.add(className);
    else el.className += " " + className;
  }
};

const removeElementClass = (el, className) => {
  if (el) {
    if (el.classList) el.classList.remove(className);
    else
      el.className = el.className.replace(
        new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"),
        " "
      );
  }
};

const addClass = (selector, className) => {
  if (!selector) return;

  const elements =
    "string" === typeof selector
      ? document.querySelectorAll(selector)
      : !(selector instanceof Element)
      ? selector
      : [selector];

  if (elements) {
    Array.prototype.forEach.call(elements, function(el, i) {
      addElementClass(el, className);
    });
  }
};

const removeClass = (selector, className) => {
  if (!selector) return;

  const elements =
    "string" === typeof selector
      ? document.querySelectorAll(selector)
      : !(selector instanceof Element)
      ? selector
      : [selector];
  if (elements) {
    Array.prototype.forEach.call(elements, function(el, i) {
      removeElementClass(el, className);
    });
  }
};

const hasClass = (selector, className) => {
  if (!selector) return;
  var el = "string" === typeof selector ? document.querySelector(selector) : selector;
  if (el) {
    if (el.classList) return el.classList.contains(className);
    else return new RegExp("(^| )" + className + "( |$)", "gi").test(el.className);
  } else {
    return false;
  }
};

const toggleClass = (selector, className) => {
  return hasClass(selector, className) ? removeClass(selector, className) : addClass(selector, className);
};

const setElementText = (selector, text) => {
  if (!selector) return;

  const elements =
    "string" === typeof selector
      ? document.querySelectorAll(selector)
      : !(selector instanceof Element)
      ? selector
      : [selector];
  if (elements) {
    Array.prototype.forEach.call(elements, function(el, i) {
      el.textContent = text;
    });
  }
};

const removeElement = selector => {
  if (!selector) return;

  const elements =
    "string" === typeof selector
      ? document.querySelectorAll(selector)
      : !(selector instanceof Element)
      ? selector
      : [selector];
  if (elements) {
    Array.prototype.forEach.call(elements, function(el, i) {
      el && el.parentElement && el.parentElement.removeChild(el);
    });
  }
};

const getElementValue = selector => {
  let element = document.querySelector(selector);
  if (element) {
    return element.value;
  }
  return null;
};

export { setCSSVar, addClass, removeClass, hasClass, toggleClass, setElementText, removeElement, getElementValue };
